module.exports = __webpack_public_path__ + "static/media/p-2.33dbf321.png";